<template>
  <div>
    <el-form ref="searchForm" :inline="true" class="searchBoxLine" :model="searchForm">
      <el-form-item label="项目名称:" clearable>
        <el-input v-model.trim="searchForm.reProjectName" placeholder="请输入项目名称" />
      </el-form-item>
      <el-form-item label="原合同编号:" prop="reOldContractNum">
        <el-input v-model.trim="searchForm.reOldContractNum" placeholder="请输入原合同编号" />
      </el-form-item>
      <el-form-item label="合同编号:" clearable>
        <el-input v-model.trim="searchForm.reNewContractNum" placeholder="请输入合同编号" />
      </el-form-item>

      <el-form-item label="代理商名称:">
        <el-input v-model.trim="searchForm.agentName" placeholder="请输入代理商名称" />
      </el-form-item>
      <el-form-item label="商务:">
        <el-input v-model.trim="searchForm.assistantName" placeholder="请输入商务名称" />
      </el-form-item>
      <el-form-item label="外销:">
        <el-input v-model.trim="searchForm.reSalesPersonName" placeholder="请输入外销名称" />
      </el-form-item>
      <el-form-item label="合同时间:">
        <div class="rj-flex" style="width:260px;">
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.createBeginTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            />
          </div>
          <div style="display: inline-block;width: 10px;text-align: center">
            -
          </div>
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.createEndTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              :picker-options="pickerOptions"
            />
          </div>
        </div>
      </el-form-item>
      <el-form-item label="部门:">
        <el-input v-model.trim="searchForm.deptName" placeholder="请输入部门名称" />
      </el-form-item>
      <el-form-item label="区域:">
        <el-input v-model.trim="searchForm.area" placeholder="请输入区域名称" />
      </el-form-item>
      <el-form-item label="退换货原因:">
        <el-select v-model="searchForm.reasonType" placeholder="请选择退还原因">
          <el-option value="" label="全部" />
          <el-option v-for="item in selectList" :key="item.value" :value="item.value" :label="item.label" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="tableLoading" @click="searchCilck">
          搜索
        </el-button>
        <el-button type="default" @click="resetForm">
          重置
        </el-button>
      </el-form-item>
    </el-form>
    <div v-loading="tableLoading" class="tableBody">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="rContractId" label="操作" align="left" fixed="left">
          <template slot-scope="scope">
            <el-button type="text" @click="handel(scope.row)">
              办理
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="rProjectName" label="项目名称" align="left" min-width="220" fixed="left" />
        <el-table-column prop="rOldContractNum" label="原合同编号" align="left" width="130" />
        <el-table-column prop="rNewContractNum" label="合同编号" align="left" width="150" />
        <el-table-column prop="rOrderUnitName" label="代理商名称" align="left" width="150" />
        <el-table-column prop="rContractType" label="合同类型" align="left" width="150" />
        <el-table-column prop="rReasonType" label="退换货原因" align="left" width="150">
          <template slot-scope="{ row }">
            {{ displayReasonType(row.rReasonType) }}
          </template>
        </el-table-column>
        <el-table-column prop="rScenarioCategory" label="场景分类" align="left" width="150" />
        <el-table-column prop="rOrderType" label="订单分类" align="left" width="150" />
        <el-table-column prop="rSalesArea" label="区域" align="left" width="150" />
        <el-table-column prop="rSalesPersonName" label="外销" align="left" width="150" />
        <el-table-column prop="assistantName" label="商务" align="left" width="90" />
        <el-table-column prop="rCreatedTime" label="合同时间" align="left" width="150">
          <template slot-scope="scope">
            {{ dateFormat(scope.row.rCreatedTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="" label="合同附件" align="left" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="checkFile(scope.row)">
              查看附件
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: right;margin-top: 10px">
        <el-pagination
          :page-sizes="[10, 20, 30, 40]"
          :page-size.sync="page.pageSize"
          :current-page.sync="page.currentPage"
          layout="total, prev, pager, next, jumper,sizes"
          :total="page.total"
          @size-change="handerSizeChange"
          @current-change="handerCurrentChange"
        />
      </div>
    </div>
    <el-dialog title="合同附件" :visible.sync="contractVisible" width="800px">
      <contract-attachment v-if="contractVisible" :contract-id="num" />
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="contractVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script type="es6">
import { orderTodolist } from '@/API';
import contractAttachment from '../../returnExchange/Chief/commom/fileDialog.vue';
import { getOrderDictData } from '@/API/international';
import { displayReasonType } from '@/constant';
export default {
  data () {
    return {
      searchForm: {
        reProjectName: '',
        reOldContractNum: '',
        reNewContractNum: '',
        agentName: '',
        reSalesPersonName: '',
        createBeginTime: '',
        createEndTime: '',
        deptName: '',
        contractStatus: '3',
        area: '',
        reasonType: '', // 退换货原因
        assistantName: ''
      },
      contractVisible: false,
      tableLoading: false,
      num: '',
      tableData: [],
      page: {
        pageSize: 10,
        total: 100,
        currentPage: 1
      },
      selectList: [], // 退换货原因下拉
      pickerOptions: {
        disabledDate: (time) => {
          if (this.searchForm.strStartTime) {
            return time.getTime() <= (new Date(this.searchForm.strStartTime)).getTime();
          }
          return false;
        }
      }
    };
  },
  components: {
    contractAttachment
  },
  computed: {

  },
  methods: {
    /**
     * 退换货原因展示名（D8）：落库值保持不变，仅展示层映射。
     *
     * @param {string} reasonType 后端返回的落库原因值
     * @returns {string} 展示文案
     */
    displayReasonType,
    handerSizeChange (val) {
      // 改变每页条数 当前页回到第一页
      this.page.currentPage = 1;
      this.doSearch();
    },
    handerCurrentChange (val) {
      // 改变当前页
      this.doSearch();
    },

    searchCilck () {
      this.page.currentPage = 1;
      this.doSearch();
    },

    resetForm () {
      this.searchForm = {
        reProjectName: '',
        reOldContractNum: '',
        reNewContractNum: '',
        agentName: '',
        reSalesPersonName: '',
        createBeginTime: '',
        createEndTime: '',
        deptName: '',
        contractStatus: '3',
        area: '',
        reasonType: ''
      };
      this.page.currentPage = 1;
      this.doSearch();
    },

    doSearch () {
      let parmas = {
        ...this.searchForm,
        reasonType: this.searchForm.reasonType || '',
        pageIndex: this.page.currentPage,
        pageSize: this.page.pageSize
      };
      orderTodolist(parmas).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.tableData = json.data.list;
          this.page.total = json.data.total;
        }
      }).catch(() => {

      });
    },
    dateFormat (time) {
      let date = new Date(time);
      let year = date.getFullYear();
      /* 在日期格式中，月份是从0开始的，因此要加0
      * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
      * */
      let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
      let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      let hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
      let minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
      let seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      // 拼接
      return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
    },
    handel (row) {
      if (row.rReasonType === '销售借用纯服务退货') {
        this.$router.push({
          name: 'salesBorrowPureServiceReturn',
          params: { contractId: row.rContractId },
          query: { applicationId: row.rContractId }
        });
        return;
      }
      // 修改成新的退换货  重新增加页面
      if (row.rContractType === '换货合同' || row.rContractType === '虚拟换货合同' || row.rContractType === '价外费用合同') {
        this.$router.push({
          name: 'orderPersionContractHandlerChangeDomestic',
          query: {
            contractType: row.rContractType,
            contractId: row.rContractId,
            rnewContractNum: row.rNewContractNum,
            rOldContractNum: row.rOldContractNum
          }
        });
      } else {
        this.$router.push({
          name: 'orderPersionContractGoodsReturn',
          query: {
            contractType: row.rContractType,
            contractId: row.rContractId,
            rOldContractNum: row.rOldContractNum
          }
        });
      }
    },
    checkFile (row) {
      // this.$router.push({ name: 'checkHt' });
      this.num = row.rContractId;
      this.contractVisible = true;
    },
    getSelectList () {
      getOrderDictData(['r_reason_type']).then(res => {
        console.log(res);
        let json = res.data;
        if (Number(json.status) === 200) {
          if (json.data && json.data.length > 0) {
            // D8：字典 label 仍为落库值“产品发运错误”，下拉展示需按 D8 改名展示；
            // value 保持字典值不变，查询仍按落库值过滤。
            this.selectList = json.data[0].dictDataVOS.map(({ dictLabel: label, dictValue: value }) => ({ label: displayReasonType(label), value }));
          }
        }
      }).catch((e) => {
        console.log(e);
      });
    }
  },
  mounted () {
    this.getSelectList();
    this.doSearch();
  },
  activated () {

  },
  destroyed () {
  }
};
</script>
<style lang="scss"></style>
